import React from 'react'

function TSSCTPView() {
    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className="text-end mb-3">
                                <button
                                    className="button-container"
                                >
                                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                                </button>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div className="top-header">
                                        <span>TSSCTPView Details</span>
                                    </div>
                                    TABLE
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default TSSCTPView
